
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/block-website",
      function () {
        return require("private-next-pages/android/local/block-website/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/local/block-website"])
      });
    }
  